import axios from "axios";
import { parseCookies } from "nookies";

const api = axios.create({
  baseURL: "https://prod-atendente.brasilconnecting.com.br/api/v1/webphone",
});

export const attendantApi = axios.create({
  baseURL: "https://prod-atendente.brasilconnecting.com.br/api/v1",
});

export const attendantLaravelApi = axios.create({
  baseURL: "https://api-agente.tallk.me/api",
});

const { "bcattendant.token": token } = parseCookies();

if (token) {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  attendantApi.defaults.headers["Authorization"] = `Bearer ${token}`;
}

const sessionToken = sessionStorage.getItem("token-session");

if (sessionToken) {
  attendantLaravelApi.defaults.headers[
    "Authorization"
  ] = `Bearer ${sessionToken}`;
}

export default api;
